import type { FormFields, FormErrors } from '../../formFields'

import { Stack, Button } from '@mui/material'
import { LoadingButton } from '@mui/lab'

import { useDisableSubmit } from '@/components/formUi/hooks/useDisableSubmit'
import { useTexts } from './hooks/useTexts'

interface Props {
  submitting: boolean
  onDiscard: () => void
  onSubmit: () => void
}

export function FormFooter(props: Props) {
  const { onSubmit } = props

  const { disableSubmit, submitting } = useDisableSubmit<FormFields, FormErrors>()
  const texts = useTexts()

  return (
    <Stack
      spacing={2}
      direction="row"
      component="footer"
      paddingTop={4}
      paddingLeft={4}
      paddingRight={4}
      justifyContent="flex-start"
    >
      <LoadingButton
        size="medium"
        type="submit"
        color="primary"
        variant="contained"
        onClick={onSubmit}
        loading={submitting}
        disabled={disableSubmit}
        data-testid="settings-gps-account-edit-save-button"
        data-trackid="settings-gps-account-edit-save-button"
      >
        {texts.save}
      </LoadingButton>

      <Button
        type="button"
        size="medium"
        color="primary"
        onClick={props.onDiscard}
        variant="text"
        data-testid="settings-gps-account-edit-cancel-button"
        data-trackid="settings-gps-account-edit-cancel-button"
      >
        {texts.cancel}
      </Button>
    </Stack>
  )
}
